import { de, en, fr, it, es } from './translations/index.js';
const languageMap = {
    de,
    en,
    fr,
    it,
    es,
};
export default {
    type: 'backend',
    init: () => { },
    read: (language, namespace, callback) => {
        // Intercept requests for special namespace `_errors`
        if (namespace === '_errors') {
            if (languageMap.hasOwnProperty(language)) {
                return callback(null, languageMap[language]);
            }
            else {
                // Fallback language: de
                return callback(null, de);
            }
        }
        else {
            return callback(null, null);
        }
    },
};
//# sourceMappingURL=backend.js.map